<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#F86031" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pt-16>
      <v-flex xs12 pt-5>
        <CarouselItem />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 pt-5>
        <SearchPage />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 pt-5>
        <SliderImages />
      </v-flex>
    </v-layout>
  </div>
</template>
  <script>
import axios from "axios";
import CarouselItem from "./carouselItem";
import SearchPage from "./searchPage";
import SliderImages from "./sliderImages";
export default {
  components: {
    CarouselItem,
    SearchPage,
    SliderImages
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      category: [],
      programs: [],
      home: {},
      ourStory: {},
      officials: [],
      goals: {},
      programlen: null,
      halfsize: null,
      model: 0,
      caraouselitems: [
        {
          image: "Home.jpg",
          quote:
            "Where humans and <br/> the wild things, <br />peacefully co-exist",
        },
        {
          image: "Home2.jpg",
          quote:
            "Among the top ten <br/> best managed <br/> Tiger Reserves <br/> in the country ",
        },
      ],
    };
  },
  beforeMount() {
    // this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/website/content",
      })
        .then((response) => {
          this.appLoading = false;
          this.home = response.data.websiteDetails;
          this.officials = response.data.officials;
          this.ourStory = response.data.websiteDetails.ourStory;
          this.goals = response.data.websiteDetails.goals;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>